export const globalSearchIt: Record<string, string> = {
  'globalSearch.placeholder': 'Cerca clienti, contatti, ordini, prodotti...',
  'globalSearch.noResults': 'Nessun risultato trovato per',
  'globalSearch.hint': 'Inizia a digitare per cercare in tutte le entità...',
  'globalSearch.customers': 'Clienti',
  'globalSearch.leads': 'Contatti',
  'globalSearch.orders': 'Ordini',
  'globalSearch.products': 'Prodotti',
  'globalSearch.appointments': 'Appuntamenti',
  'globalSearch.measurements': 'Misure',
  'globalSearch.wedding': 'Matrimonio',
  'globalSearch.stage': 'Fase',
  'globalSearch.source': 'Fonte',
  'globalSearch.status': 'Stato',
  'globalSearch.created': 'Creato',
};
